import { ParsedUrlQuery } from 'querystring';

// Remove empty params from a query object, unless the param is 'filters' and is not undefined.
const removeEmptyParams = <T extends ParsedUrlQuery>(query: T): Partial<T> => (
  Object.keys(query).reduce<Partial<T>>((newQuery, key: keyof T) => {
    const queryValue = query[key];
    if ((queryValue !== undefined && (Array.isArray(queryValue) || typeof queryValue === 'string') && queryValue.length > 0)
      || (key === 'filters' && queryValue !== undefined)) {
      // eslint-disable-next-line no-param-reassign
      newQuery[key] = queryValue;
    }
    return newQuery;
  }, {})
);

export default removeEmptyParams;
